import httpService from "./httpService";
import utils from "./utils";

export default {

  findAll(example) {
    return httpService.get("/docRelation", {params: example});
  },
  findAllByListId(lstId) {
    return httpService.get("/docRelation/" + lstId,);
  },
  findAllVbLK(example) {
    return httpService.get("/docRelation/findAllVbLK", {params: example});
  },
  findAllByAttachedType(form, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(form, pageable);
    return httpService.get("/docRelation/findAllByAttachedType", { params: params });
  }
}



// WEBPACK FOOTER //
// ./src/services/docRelationService.js